<template>
  <div class="ch-component-warpper">
    <div class="ch-component ch-detail-component">
      <v-container fluid grid-list-lg class="ch-menu-wrapper ch-detail-page">
        <v-layout row wrap>
          <v-flex xs-12>
            <span class="ch-component-title ml-2">AUDIT LOG Detail</span>
          </v-flex>
        </v-layout>
      </v-container>
      <audit-logs-detail-info></audit-logs-detail-info>
      <audit-log-print-view></audit-log-print-view>
    </div>
  </div>
</template>

<script>
  import { navigationEventBus } from '@/components/navigation/navigationEventBus';
  import AuditLogsDetailInfo from '@/components/admin/auditLogs/AuditLogsDetailInfo';
  import AuditLogPrintView from '@/components/admin/auditLogs/AuditLogPrintView';

  export default {
    data() {
      return {
        // NOTE: Full screen dialog
        dialog: false,
        navigationDrawer: true,
      };
    },
    methods: {
      // NOTE: toogle navigation drawer
      toogleDrawer() {
        navigationEventBus.$emit('toogle');
      },
    },
    mounted() {
      navigationEventBus.$on('ondrawerHide', () => {
        this.navigationDrawer = false;
      });
      navigationEventBus.$on('ondrawerShow', () => {
        this.navigationDrawer = true;
      });
    },
    components: {
      AuditLogsDetailInfo, AuditLogPrintView,
    },
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/AuditLogsDetail.vue